import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IpcData, parseIpcData } from '../../ipcData';
import { IpcResponse } from '../models/ipc-response.interface';
import { environment } from '@selftest/env/environment';

@Injectable({
	providedIn: 'root',
})
export class TableService {
	private httpClient = inject(HttpClient);
	private requestUrl: string = environment.server + '/v2/Misc/selftest?p=superSecret&format=json';

	fetchData(): Observable<IpcData[]> {
		return this.httpClient.get(this.requestUrl).pipe(
			map((data: any) => {
				return data.status ? (data.data as IpcResponse[]).map((item) => parseIpcData(item)) : [];
			})
		);
	}
}
